<template>
    <div class="mobi-lang-switcher">
        <q-expansion-item v-model="expand" expand-separator>
            <template v-slot:header>
                <div class="mobi-lang-selected">
                    <img
                        v-if="setFlag(langSelect)"
                        :src="setFlag(langSelect)"
                    />
                    <span>{{ langSelect.name }}</span>
                </div>
            </template>
            <q-item
                v-for="(lang, index) in locales"
                :key="index"
                clickable
                @click="changeLocale(lang)"
            >
                <q-item-section>
                    <div class="mobi-lang-option">
                        <img v-if="setFlag(lang)" :src="setFlag(lang)" />
                        <span>{{ lang.name }}</span>
                    </div>
                </q-item-section>
            </q-item>
        </q-expansion-item>
    </div>
</template>

<script>
import userConfigurationsService from '@/services/modules/userConfigurations'
import store from '@/store'

const loadingKeys = {
    fetchingUserConfigurations: 'fetching-user-configurations',
    savingUserConfigurations: 'saving-user-configurations',
}

export default {
    name: 'MobiLanguageSelector',

    data() {
        return {
            langSelect: '',
            i18Keys: '',
            expand: false,
        }
    },

    computed: {
        locales() {
            return store.getters['locale/localeList']
        },

        locale() {
            return store.getters['locale/currentLocale']
        },

        userLogged() {
            return store.getters['session/user']
        },

        currency() {
            return store.getters['currency/currentCurrency']
        },

        isAuthenticated() {
            return store.getters['session/isAuthenticated']
        },
    },

    watch: {
        locale(value) {
            this.langSelect = value
        },
    },

    mounted() {
        this.langSelect = this.locale
        store.commit('locale/setLocale', this.locale)
    },

    methods: {
        changeLocale(locale) {
            this.langSelect = locale
            store.commit('locale/changeLocale', locale.key)
            // if (this.isAuthenticated) {
            //     let parameters = {
            //         token: this.userLogged.token,
            //         configurations: [
            //             {
            //                 locale: locale.key,
            //                 currency: this.currency.id,
            //             },
            //         ],
            //     }
            //     this.updateUserConfiguration(parameters)
            // }
            this.expand = false
        },

        setFlag(lang) {
            let src = lang.key
                ? require('@/assets/images/flags/32/' +
                      lang.key.split('-')[1] +
                      '.png')
                : null
            return src ? src : null
        },

        async updateUserConfiguration(parameters) {
            this.loadingAdd(loadingKeys.savingUserConfigurations)

            let response = await userConfigurationsService.update(parameters)

            if (response.status !== 200) {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', {
                        message: response.data.message,
                    }),
                })
            }
            this.loadingRemove(loadingKeys.savingUserConfigurations)
        },
    },
}
</script>
